/* eslint-disable prefer-template */
// must be ie11 compatible
const logger = require('redux-logger');

const regex = /@@redux-form\/(BLUR|FOCUS|CHANGE)/g;

module.exports = function logging(name) {
    return logger.createLogger({
        collapsed: function collapsed(getState, action, logEntry) {
            return !logEntry.error;
        },
        titleFormatter: function titleFormatter(action, time, took) {
            return '[' + name + '] ' + action.type + ' (' + took.toFixed(2) + 'ms)';
        },
        predicate: function predicate(getState, action) {
            return !action.type.match(regex);
        },
    });
};
